import { createAsyncThunk } from '@reduxjs/toolkit';
import { MainInfoFormState } from '../../pages/profile/company/components/main';
import AccountsApi from '../../services/api/AccountsApi';
import CompanyApi from '../../services/api/CompanyApi';
import { showError } from '../../utils/utils';
import { RootState } from '../../types';

import { setPush } from './app';

const getCompanyInfo = createAsyncThunk(
  'company-info/getCompanyInfo',
  async (payload: string | undefined, thunkAPI) => {
    const token = payload || (thunkAPI.getState() as RootState).auth.account?.token;
    const response = await CompanyApi.getCompanyInfo(token);
    if (response.status === 200) {
      return response.data;
    }
    return undefined;
  }
);

const getCompanies = createAsyncThunk(
  'company-info/getCompanies',
  async (payload: string | undefined, thunkAPI) => {
    const token = payload || (thunkAPI.getState() as RootState).auth.account?.token;
    const response = await CompanyApi.getRelatedCompanies(token);
    if (response.status === 200) {
      return response.data;
    }
    return undefined;
  }
);

const getBanksAccounts = createAsyncThunk(
  'company-info/getBanksAccounts',
  async () => {
    const response = await AccountsApi.getBanksAccounts();
    if (response.status === 200) {
      return response.data;
    }
    return undefined;
  }
);

const updateCompany = createAsyncThunk(
  'company-info/updateCompany',
  async (payload: { orgId: number } & MainInfoFormState, thunkAPI) => {
    try {
      const response = await CompanyApi.updateCompany(payload);

      if (response.status === 200) {
        thunkAPI.dispatch(getCompanyInfo());
        thunkAPI.dispatch(
          setPush({
            message: 'Данные успешно изменены',
            type: 'success',
          })
        );
        return response.data;
      }
      return undefined;
    } catch (err) {
      showError(err, thunkAPI);
    } finally {
      //
    }
  }
);

export { getCompanyInfo, getCompanies, getBanksAccounts, updateCompany };
